/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Export CCSL" |
*
* @param {Ccsl_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_export_button = /** @type {((inputs?: Ccsl_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export CCSL")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт CCSL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口 CCSL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSL をエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CCSL निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar CCSL")
	return /** @type {LocalizedString} */ ("Export CCSL")
});